import styled from '@emotion/styled';

export const SContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
